import React from 'react'

const Video = () => {
  return (
    <svg
      fill='none'
      height='26'
      viewBox='0 0 26 26'
      width='26'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.5 5.5h-2a1 1 0 00-1 1v17a1 1 0 001 1h17a1 1 0 001-1v-2'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M24.5 2.5a1 1 0 00-1-1h-18a1 1 0 00-1 1v18a1 1 0 001 1h18a1 1 0 001-1v-18z'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M12.3 15.272a.54.54 0 01-.8-.472V8.036a.54.54 0 01.807-.468l5.922 3.384a.539.539 0 010 .936L12.3 15.272z'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Video
